<div class="settings-container card-builder-settings-container">
  <div class="settings-header">
    <div class="card-builder-header">
      <h6>Settings</h6>
      <rappider-button text="Edit Card JSON Data"
                       [icon]="{name: 'fa-solid fa-brackets-curly'}"
                       (click)="onEditJsonData()">
      </rappider-button>
    </div>
    <hr>
    <nz-tabset #cardSettingsTabs
               nzType="card"
               [nzSelectedIndex]="activeTabIndex"
               [(nzSelectedIndex)]="activeTabIndex">
      <nz-tab [nzTitle]="cardSettingsTabIconTemplate">
        <ng-template #cardSettingsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-grid',
            title: activeTabIndex === 0 ? 'Card Settings' : '',
            tooltip: 'Card Settings',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="itemActionsTabIconTemplate">
        <ng-template #itemActionsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-ballot',
            title: activeTabIndex === 1 ? 'Item Actions' : '',
            tooltip: 'Item Actions',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
    </nz-tabset>
  </div>

  <div class="settings-tabs-content">
    <div class="tab-pane-content" *ngIf="activeTabIndex === 0">
      <div class="settings-content">
        <div class="settings-form-content">
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Card Icon:
            </b>
          </span>
        </div>
        <rappider-icon-picker-wrapper *ngIf="value"
                                      [ngModel]="value?.iconConfig"
                                      (ngModelChange)="onIconConfigChange($event)"></rappider-icon-picker-wrapper>
        <small class="help-text">Select an icon to display on card items</small>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Title Field Name:
            </b>
          </span>
        </div>
        <rappider-select *ngIf="value && entityFields && entityFields.length > 0"
                         [ngModel]="value?.titleFieldName"
                         [options]="entityFields"
                         [optionMode]="OptionMode.Options"
                         [settings]="selectSettings"
                         (ngModelChange)="onTitleFieldNameChange($event)"
                         placeholder="Select field for card title"></rappider-select>
        <div *ngIf="!entityFields || entityFields.length === 0" class="no-fields-message">
          <small style="color: #ff4d4f;">⚠️ No entity fields available. Please configure entity fields first.</small>
        </div>
        <small class="help-text">The field name from your data that will be used as the card title</small>
      </div>

            <div class="form-control-area">
              <div class="label">
                <span>
                  <b>
                    Subtitles:
                  </b>
                </span>
              </div>
              <div class="switch-container">
                <rappider-switch [ngModel]="useSubtitleFunction"
                                 (ngModelChange)="onUseSubtitleFunctionChange($event)"></rappider-switch>
                <span class="switch-label">{{ useSubtitleFunction ? 'Function' : 'Field Names' }}</span>
              </div>
              <div *ngIf="!useSubtitleFunction">
                <rappider-row-select *ngIf="entityFields && entityFields.length > 0"
                                     [ngModel]="subtitleRowSelectValueProperty"
                                     [columns]="subtitleRowSelectColumns"
                                     [orderable]="true"
                                     [addButton]="subtitleRowSelectAddButton"
                                     [editButton]="subtitleRowSelectEditButton"
                                     [cancelButton]="subtitleRowSelectCancelButton"
                                     [saveButton]="subtitleRowSelectSaveButton"
                                     [addButtonVisible]="true"
                                     [hasInitialEmptyRow]="false"
                                     (ngModelChange)="onSubtitleRowSelectChange($event)"></rappider-row-select>
                <div *ngIf="!entityFields || entityFields.length === 0"
                     class="no-fields-message">
                  <small style="color: #ff4d4f;">⚠️ No entity fields available. Please configure entity fields first.</small>
                </div>
                <small class="help-text">
                  Field names that will be displayed as subtitles below the title.
                </small>
              </div>
              <div *ngIf="useSubtitleFunction"
                   class="monaco-editor-container">
                <rappider-monaco-code-editor [ngModel]="subtitleFunctionString"
                                             [options]="monacoEditorOptions"
                                             (ngModelChange)="onSubtitleFunctionChange($event)"></rappider-monaco-code-editor>
                <small class="help-text">
                  Define a custom function to dynamically generate subtitle content for each card item based on its data
                </small>
              </div>
            </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Description:
            </b>
          </span>
        </div>
        <div class="switch-container">
          <rappider-switch [ngModel]="useDescriptionFunction"
                          (ngModelChange)="onUseDescriptionFunctionChange($event)"></rappider-switch>
          <span class="switch-label">{{ useDescriptionFunction ? 'Function' : 'Field Name' }}</span>
        </div>
        <div *ngIf="!useDescriptionFunction">
          <rappider-select *ngIf="value && entityFields && entityFields.length > 0"
                           [ngModel]="value?.descriptionFieldName"
                           [options]="entityFields"
                           [optionMode]="OptionMode.Options"
                           [settings]="selectSettings"
                           (ngModelChange)="onDescriptionFieldNameChange($event)"
                           placeholder="Select field for card description"></rappider-select>
          <div *ngIf="!entityFields || entityFields.length === 0" class="no-fields-message">
            <small style="color: #ff4d4f;">⚠️ No entity fields available. Please configure entity fields first.</small>
          </div>
          <small class="help-text">
            The field name from your data that will be used as the card description
          </small>
        </div>
        <div *ngIf="useDescriptionFunction" class="monaco-editor-container">
          <rappider-monaco-code-editor [ngModel]="descriptionFunctionString"
                                      [options]="monacoEditorOptions"
                                      (ngModelChange)="onDescriptionFunctionChange($event)"></rappider-monaco-code-editor>
          <small class="help-text">
            Define a custom function to dynamically generate description content for each card item based on its data
          </small>
        </div>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Card Item Click Behavior:
            </b>
          </span>
        </div>
        <rappider-select *ngIf="value"
                         [ngModel]="value?.cardItemClickBehavior"
                         [options]="actionBehaviorOptions"
                         [optionMode]="OptionMode.Options"
                         [settings]="selectSettings"
                         (ngModelChange)="onCardItemClickBehaviorChange($event)"
                         placeholder="Select click behavior"></rappider-select>
        <small class="help-text">What happens when a card is clicked</small>
      </div>

      <div class="form-control-area" *ngIf="value && value.cardItemClickBehavior === ActionBehavior.Route">
        <div class="label">
          <span>
            <b>
              Card Item Router Link:
            </b>
          </span>
        </div>
        <rappider-textbox *ngIf="value"
                          [ngModel]="value?.cardItemRouterLink"
                          (ngModelChange)="onCardItemRouterLinkChange($event)"
                          placeholder="e.g., /items/:id"></rappider-textbox>
        <small class="help-text">Route path when card item click behavior is set to Route</small>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Show Search with AI Button:
            </b>
          </span>
        </div>
        <rappider-switch *ngIf="value"
                         [ngModel]="value?.showSearchWithAiButton"
                         (ngModelChange)="onShowSearchWithAiButtonChange($event)"></rappider-switch>
        <small class="help-text">Display an AI-powered search button in the card view</small>
      </div>
        </div>
      </div>
    </div>

    <div class="tab-pane-content" *ngIf="activeTabIndex === 1">
      <div class="settings-content">
        <div class="settings-form-content">
          <div class="form-control-area">
            <rappider-actions-input #editActionsInput
                                    [(ngModel)]="editActions"
                                    [hideDragIcon]="true"
                                    [showVisibilityToggle]="true"
                                    [customDeleteAction]="true"
                                    [hideAddButton]="true"
                                    [hideDeleteButton]="true"
                                    (ngModelChange)="onEditActionsChange($event)"
                                    (visibilityToggle)="onEditActionVisibilityToggle($event)"
                                    (customDelete)="onEditActionCustomDelete($event)"></rappider-actions-input>
          </div>

          <div class="form-control-area">
            <rappider-actions-input #deleteActionsInput
                                    [(ngModel)]="deleteActions"
                                    [hideDragIcon]="true"
                                    [showVisibilityToggle]="true"
                                    [customDeleteAction]="true"
                                    [hideAddButton]="true"
                                    [hideDeleteButton]="true"
                                    (ngModelChange)="onDeleteActionsChange($event)"
                                    (visibilityToggle)="onDeleteActionVisibilityToggle($event)"
                                    (customDelete)="onDeleteActionCustomDelete($event)"></rappider-actions-input>
            <small class="help-text">Configure item action buttons for card items. Use eye icon to show/hide.</small>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- TAB ICON TEMPLATE -->
<ng-template #tabIcon
             let-icon="icon"
             let-title="title"
             let-tooltip="tooltip"
             let-tooltipPlacement="tooltipPlacement">
  <div class="tab-icon"
       [nzTooltipTitle]="tooltip"
       [nzTooltipPlacement]="tooltipPlacement || 'bottom'"
       nz-tooltip>
    <i [ngClass]="icon"></i>
    <p *ngIf="title">{{ title }}</p>
  </div>
</ng-template>
<!-- / TAB ICON TEMPLATE -->



